/**
 *
 * PasswordChanger
 *
 */

import { Component } from "react";
import * as PropTypes from "prop-types";
import styled from "styled-components";
import TextField from "basicComponents/TextField/TextField";
import Button from "basicComponents/ActionButton/ActionButton";
import Header from "basicComponents/Header/Header";
import { FormattedMessage } from "react-intl";
import GlobalMessages from "messages/messages";
import messages from "./messages";

class PasswordChanger extends Component {
  static propTypes = {
    failedMessages: PropTypes.object,
    onChangePassword: PropTypes.func.isRequired,
  };

  static defaultProps = {
    failedMessages: {
      messages: [],
    },
  };

  state = {
    oldPassword: "",
    newPassword: "",
    newPasswordConfirm: "",
    match: true,
    passwordValid: true,
    success: false,
  };

  handleOldPasswordChanged = e => {
    this.setState({
      oldPassword: e.target.value,
      passwordValid: true,
    });
  };

  handleNewPasswordChanged = e => {
    this.setState({
      newPassword: e.target.value,
      match: true,
    });
  };

  handleConfirmChanged = e => {
    this.setState({
      newPasswordConfirm: e.target.value,
      match: true,
    });
  };

  handleSuccess = () => {
    this.setState({
      oldPassword: "",
      newPassword: "",
      newPasswordConfirm: "",
      match: true,
      passwordValid: true,
      success: true,
    });
  };

  handleConfirm = () => {
    let failed = false;
    if (this.state.oldPassword.length === 0) {
      this.setState({
        passwordValid: false,
      });
      failed = true;
    }
    if (this.state.newPassword !== this.state.newPasswordConfirm) {
      this.setState({
        match: false,
      });
      failed = true;
    }
    if (failed) {
      return;
    }

    // clear success text on confirm button click
    this.setState({
      success: false,
    });

    this.props.onChangePassword(
      this.state.oldPassword,
      this.state.newPassword,
      this.handleSuccess,
    );
  };

  isNewPasswordDisabled() {
    return this.state.oldPassword.length === 0 || this.props.inProgress;
  }

  isNewPasswordConfirmDisabled() {
    return this.isNewPasswordDisabled() || this.state.newPassword.length === 0;
  }

  render() {
    const { failedMessages } = this.props;

    return (
      <Wrapper>
        <Header>
          <FormattedMessage {...messages.changePassword} />
        </Header>
        <FieldWrapper>
          <TextField
            keepPlaceholder
            placeholder={messages.oldPassword}
            focusTextField={!!this.state.oldPassword}
            id="oldPassword"
            type="password"
            value={this.state.oldPassword}
            onChange={this.handleOldPasswordChanged}
            required
            error={!this.state.passwordValid || !!failedMessages.oldPassword}
            disabled={this.props.inProgress}
          />
        </FieldWrapper>
        <FieldWrapper>
          <TextField
            disabled={this.isNewPasswordDisabled()}
            placeholder={GlobalMessages.password}
            focusTextField={!!this.state.password}
            id="newPassword"
            type="password"
            value={this.state.newPassword}
            onChange={this.handleNewPasswordChanged}
            error={!this.state.match || !!failedMessages.newPassword}
            required
          />
        </FieldWrapper>
        <FieldWrapper>
          <TextField
            placeholder={GlobalMessages.passwordConfirm}
            focusTextField={!!this.state.passwordConfirm}
            id="newPasswordConfirm"
            type="password"
            value={this.state.newPasswordConfirm}
            error={!this.state.match || !!failedMessages.newPassword}
            onChange={this.handleConfirmChanged}
            disabled={this.isNewPasswordConfirmDisabled()}
            required
          />
        </FieldWrapper>
        <WarningField>
          {failedMessages.messages.map((message, index) => (
            // check this index as key is anti pattern, in the failedMessages.messages there are no Id available for a unique key
            // eslint-disable-next-line react/no-array-index-key
            <div className="registerWarning" key={message + index}>
              - {message}
            </div>
          ))}
          {!this.state.match && (
            <div className="registerWarning">
              - <FormattedMessage {...GlobalMessages.passwordsDontMatch} />
            </div>
          )}
        </WarningField>
        <SuccessField data-cy="successMessage">
          {this.state.success && (
            <FormattedMessage {...messages.passwordChangedSuccess} />
          )}
        </SuccessField>
        <FieldWrapper>
          <ButtonWrapper>
            <Button
              id="confirmButton"
              onClick={this.handleConfirm}
              variant="contained"
              disabled={
                this.state.oldPassword.length === 0 || this.props.inProgress
              }
              color="primary"
            >
              <FormattedMessage {...GlobalMessages.changePassword} />
            </Button>
          </ButtonWrapper>
        </FieldWrapper>
      </Wrapper>
    );
  }
}

const Wrapper = styled.div`
  ${({ theme }) => theme.tabletPortraitUp`
    min-width: 22rem;
  `};
`;

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
`;

const FieldWrapper = styled.div`
  margin-bottom: ${({ theme }) => theme.margin}rem;
`;
const SuccessField = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: ${({ theme }) => theme.margin}rem;
  color: green;
`;

const WarningField = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: ${({ theme }) => theme.margin}rem;
  color: ${({ theme }) => theme.palette.error.main};
`;

export default PasswordChanger;
